var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-wrap-child"},[_c('img',{attrs:{"src":require("../../assets/img/fontimg/empty.png"),"alt":""}}),_c('p',[_vm._t("default",function(){return [_c('span',[_vm._v("当前暂无数据哦~")])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }